import { render } from "./SetNewPassword.vue?vue&type=template&id=f67bd862"
import script from "./SetNewPassword.vue?vue&type=script&lang=js"
export * from "./SetNewPassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\BuildAgent\\_work\\145\\s\\MyMortgage_New\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__